import * as types from '../types.js';

export default {

	html: `
		<style>
			#login .title
			{
				padding-bottom: var(--space-md);
				border-bottom: 1px solid var(--color-border);
			}
			#login label
			{
				display: block;
			}
			#login .tal { width: 70%; margin-left: auto; margin-right: auto; }
			#login #username,
			#login #password {
				width: 100%;
				box-sizing: border-box;
			}
			#login .login-logo-aws {
				display: none;
				margin-bottom: var(--space-md);
				text-align: center;
				padding: var(--space-sm) 0;
				width: 100%;
			}
			#login .login-logo-sial {
				display: block;
				margin-bottom: var(--space-md);
				text-align: center;
				padding: var(--space-sm) 0;
				width: 100%;
			}
			#login .login-logo-sial img {
				height: auto;
				max-height: 10rem;
				max-width: 100%;
				width: auto;
				object-fit: contain;
				background: transparent;
				display: block;
				margin: 0 auto;
			}
			#login .login-logo-aws img {
				height: auto;
				max-height: 5.5rem;
				max-width: min(100%, 28rem);
				width: auto;
				object-fit: contain;
				background: transparent;
				display: block;
				margin: 0 auto;
			}
			#login .login-logo-aws .login-aws-subtitle {
				margin: var(--space-sm) 0 0;
				font-size: 0.95rem;
				font-weight: 600;
				color: var(--color-text);
				text-align: center;
				line-height: 1.35;
			}
		</style>
		<form id="login" class="form">
			<div id="login-logo-sial" class="login-logo-sial">
				<img src="/img/logo_sial_grey.png" alt="SIAL">
			</div>
			<div id="login-logo-aws" class="login-logo-aws">
				<img src="img/logo_sessp_secretaria_saude_sp.png" alt="Secretaria de Saúde do Estado de SP">
				<p class="login-aws-subtitle">Secretaria de Saúde do Estado de SP</p>
			</div>
			<div class="title">
				Autenticação
				<span id="login-env-badge"></span>
			</div>
			<div class="tal mtl">
				<label>Usuário
					<input id="username" name="username" type="text">
				</label>
				<label>Senha
					<input id="password" name="password" type="password">
				</label>
			</div>
			<div class="fsb mtl">
				<a class='bn_Link link'>Alterar a Senha</a>
				<button class='bn_Enter button'>Acessar</button>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#login',
		init(formset)
		{
			this.setValues({ 'login.password': null });
			const badge = document.getElementById('login-env-badge');
			if (badge) {
				const h = window.location.hostname;
				// QA-VPN: IP interno ou DNS público https://qa.sial.run:1610
				const isQaVpn = h === '10.10.0.219' || h === 'qa.sial.run';
				const isQA = isQaVpn || h === '54.207.230.11' || h === 'qa.sialwms.com.br';
				const isDev = h === 'localhost' && window.location.port === '8001';
				const baseStyle = 'margin-left: 0.5rem; padding: 0.15rem 0.5rem; border-radius: 4px; font-size: 0.75rem; font-weight: bold;';
				if (isQaVpn) {
					badge.textContent = 'Ambiente QA';
					badge.style.cssText = baseStyle + ' background: #2196f3; color: #fff;';
				} else if (isQA) {
					badge.textContent = 'AMBIENTE DE TESTE';
					badge.style.cssText = baseStyle + ' background: #2196f3; color: #fff;';
				} else if (isDev) {
					badge.textContent = 'AMBIENTE DEV';
					badge.style.cssText = baseStyle + ' background: #ff9800; color: #000;';
				}
			}
			// Logo SIAL (sempre visível) e logo institucional AWS (apenas em hosts específicos).
			// Palmas: logo em /img/palmaslogo.png (só o deploy PALMAS copia esse arquivo para dist).
			const logoAwsEl = document.getElementById('login-logo-aws');
			if (logoAwsEl) {
				const h = window.location.hostname;
				const isAws = h === '54.207.230.11' || h === '177.71.248.43'
					|| h.includes('amazonaws') || h.includes('sial.ibl') || h.endsWith('sialwms.com.br');
				logoAwsEl.style.display = isAws ? 'block' : 'none';
				const isPalmas = h === 'palmas.sialwms.com.br';
				if (isAws && isPalmas) {
					const logoImg = logoAwsEl.querySelector('img');
					const subEl = logoAwsEl.querySelector('.login-aws-subtitle');
					if (logoImg) {
						logoImg.src = '/img/palmaslogo.png';
						logoImg.alt = 'Secretária de Saúde - Palmas - TO';
					}
					if (subEl) {
						subEl.textContent = 'Secretaria Municipal de Saúde — Palmas (TO)';
					}
				}
			}
			Object.getPrototypeOf(this).init.call(this);
		}
	},

	fields: [
		{ properties: { selector: '#username' } },
		{ properties: { selector: '#password' }, types: [types.password()] },
	]

}

